import api from '../../store/config/api';

// comment API still returns old-style messages
import { MESSAGE as SCHEMA } from '../../schemas';

export const [
  ADD_COMMENT,
  ADD_COMMENT_REQUEST,
  ADD_COMMENT_SUCCESS,
  ADD_COMMENT_FAILURE
] = api.buildTypes('ADD_COMMENT');

export function addComment({ teamName, runID, body }) {
  return {
    type: ADD_COMMENT,
    payload: {
      url: `/teams/${teamName}/runs/${runID}/comments`,
      schema: SCHEMA,
      options: {
        method: 'POST',

        // JSON payload is { body: "content of message" }
        body: {
          body
        }
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/comment.js